export const fontColor = '#e3e3e3';
export const backgroundColor = '#16161d';
export const emphasis = '#ff3399';
export const emphasisDarker = '#891751';
export const emphasis2 = '#00d68e';
